/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebmanual2Inputs */

const en_placewebmanual2 = /** @type {(inputs: Placewebmanual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create without a website`)
};

const de_placewebmanual2 = /** @type {(inputs: Placewebmanual2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Website anlegen`)
};

/**
* | output |
* | --- |
* | "Create without a website" |
*
* @param {Placewebmanual2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebmanual2 = /** @type {((inputs?: Placewebmanual2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebmanual2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebmanual2(inputs)
	return de_placewebmanual2(inputs)
});
export { placewebmanual2 as "placeWebManual" }